import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import { Note } from "./note"
import { INote } from "./note.types"
import { AccountNote } from "@/api/backofficeRest/generated/model"

export type INoteRaw = AccountNote

export const NoteParser: IParser<INote, INoteRaw> = {
  toDomain: (data: INoteRaw) => {
    try {
      return new Note(
        data.id,
        dayjs(data.createdDate),
        data.summary,
        data.content ?? "",
        data.user,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
